import { render, staticRenderFns } from "./BuildBatch.vue?vue&type=template&id=1a923fbc"
import script from "./BuildBatch.vue?vue&type=script&lang=js"
export * from "./BuildBatch.vue?vue&type=script&lang=js"
import style0 from "./BuildBatch.vue?vue&type=style&index=0&id=1a923fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports